export default {
  rowActions: {
    actions: "Actions",
  },
};
